/**
 * Array of feature names.
 * Add treatments name exactly as created.
 */
export const TREATMENTS = [
  "MONITOR_MEDIA_AUTHORS_LIST",
  "MI_MONITOR_3_REDIRECT"
];
